import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHistory } from "@fortawesome/free-solid-svg-icons";
import { getStatusStyles } from "../../../utils/attendanceHelpers";

const AttendanceDailyTable = ({ data, pageNumber, pageSize, onRowClick }) => {
    return (
        <table className="w-full text-left border-collapse min-w-[900px]">
            <thead className="sticky top-0 z-10 bg-gray-50/95 backdrop-blur-sm shadow-sm">
                <tr className="text-[10px] font-black text-gray-400 uppercase tracking-widest border-b border-gray-200">
                    <th className="py-4 pl-6 pr-4 w-16">SR.NO</th>
                    <th className="py-4 px-4">EMPLOYEE</th>
                    <th className="py-4 px-4 w-32">DATE</th>
                    <th className="py-4 px-4 w-24">CHECK IN</th>
                    <th className="py-4 px-4 w-24">CHECK OUT</th>
                    <th className="py-4 px-4 w-28">WORK HOURS</th>
                    <th className="py-4 px-4 w-32">STATUS</th>
                    <th className="py-4 pr-6 pl-4 w-16 text-right">LOG</th>
                </tr>
            </thead>
            <tbody className="text-sm">
                {data.map((row, idx) => (
                    <tr key={row.attendanceId} className="border-b border-gray-100 hover:bg-gray-50/50 transition-colors">
                        <td className="py-4 pl-6 pr-4 font-bold text-gray-500 text-xs">{(pageNumber - 1) * pageSize + idx + 1}</td>
                        <td className="py-4 px-4">
                            <div className="flex items-center gap-3">
                                <div className="w-8 h-8 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-500 font-bold text-xs uppercase shrink-0">
                                    {row.employeeName ? row.employeeName.charAt(0) : "U"}
                                </div>
                                <div className="flex flex-col">
                                    <span className="font-black text-[#1E293B] text-xs">{row.employeeName}</span>
                                    <span className="text-[10px] text-gray-400 font-bold">{row.empId}</span>
                                </div>
                            </div>
                        </td>
                        <td className="py-4 px-4">
                            <div className="flex flex-col">
                                <span className="font-bold text-gray-700 text-xs">{row.date}</span>
                                <span className="text-[10px] font-semibold text-gray-400">{row.dayOfWeek}</span>
                            </div>
                        </td>
                        <td className="py-4 px-4 font-bold text-gray-600 text-xs">{row.checkIn}</td>
                        <td className="py-4 px-4 font-bold text-gray-600 text-xs">{row.checkOut}</td>
                        <td className="py-4 px-4 font-bold text-gray-600 text-xs">{row.workHours}</td>
                        <td className="py-4 px-4">
                            <span className={`px-2.5 py-1 rounded-md text-[9px] font-black uppercase tracking-wider inline-block ${getStatusStyles(row.status).badge}`}>
                                {row.status}
                            </span>
                        </td>
                        <td className="py-4 pr-6 pl-4 text-right">
                            <button
                                onClick={() => onRowClick(row, row.employeeName)}
                                className="p-1.5 text-indigo-600 hover:bg-indigo-50 rounded-md transition-colors"
                                title="View Timeline"
                            >
                                <FontAwesomeIcon icon={faHistory} />
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default AttendanceDailyTable;
